import {
  Form,
  Formik,
  FormikConfig,
  FormikHelpers,
  FormikProps,
  FormikValues,
} from 'formik';
import './QueryFilter.scss';
import React, { useEffect } from 'react';
import { II18nextPrefix } from 'types/components/components.interface';
import { FormButtonFilter, FormGrid } from 'components/molecules';
import QueryFilterButtons from './buttons/QueryFilterButtons';
import QueryFilterForm from './form/QueryFilterForm';
import QueryFilterLabels from './labels/QueryFilterLabels';

export interface IQueryFilterProps<Values extends FormikValues = FormikValues>
  extends Omit<FormikConfig<Values>, 'onSubmit'>,
    II18nextPrefix {
  onSubmit?: (
    values: Values,
    formikHelpers: FormikHelpers<Values>
  ) => void | Promise<any>;
}

const QueryFilter = <T extends FormikValues = FormikValues>({
  i18nextPrefix,
  children,
  onSubmit = () => {},
  ...props
}: IQueryFilterProps<T>) => {
  return (
    <Formik onSubmit={onSubmit} {...props}>
      {children}
    </Formik>
  );
};

QueryFilter.ButtonOpener = FormButtonFilter;
QueryFilter.InputsGrid = FormGrid;
QueryFilter.Form = QueryFilterForm;
QueryFilter.FormButtons = QueryFilterButtons;
QueryFilter.Labels = QueryFilterLabels;

export default QueryFilter;
